import api from "../atlasApi";

export const serviceGetOrUpdateSettings = (data, token) => {
  return api.post("/horizon/user-settings/", data, {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "multipart/form-data",
    },
  });
};

export const serviceGetImagary = (data, token) => {
  return api.post("/horizon/cesium-ion-assets/", data, {
    headers: {
      Authorization: "Token " + token,
      // "Content-Type": "multipart/form-data",
    },
  });
};
